import React, { useState } from "react";
import { motion } from "framer-motion";

const Bell = ({ position }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  // Function to play sound
  const playBellSound = () => {
    const audio = new Audio("/bell.mp3");
    audio.play();
  };

  // Function to handle touch/click animation
  const handleTap = () => {
    if (!isAnimating) {
      setIsAnimating(true);
      playBellSound();

      setTimeout(() => {
        setIsAnimating(false);
      }, 600);
    }
  };

  const isMobile = window.innerWidth <= 768;

  const styles = {
    position: "absolute",
    top: isMobile ? "24.5%" : "26.9%",
    transform: "translateY(-50%)",
    zIndex: 1000,
  };

  const leftStyle = {
    ...styles,
    left: 0,
  };

  const rightStyle = {
    ...styles,
    right: 0,
  };

  return (
    <div style={position === "left" ? leftStyle : rightStyle}>
      <motion.img
        src="/bell.png"
        alt="Bell"
        style={{
          width: isMobile ? "200px" : "250px",
          height: isMobile ? "150px" : "200px",
        }}
        animate={
          isAnimating ? { rotate: [-15, 15, -10, 10, -5, 5, 0] } : { rotate: 0 }
        }
        transition={{ duration: 0.6 }}
        onTap={handleTap}
      />
    </div>
  );
};

export default Bell;
